/**
 * Home GSAP animations
 */

var Gsap = (function($) {
  function initGsap() {
    gsap.registerPlugin(ScrollTrigger);

    var $header = $(".header");
    var $slider = $(".home-hero-slider");
    var $subtitle = $(".home-hero__subtitle");
    var $titleSpans = $(".home-hero__title span");
    var $heroLogo = $(".home-hero-logo");
    var $hamburger = $(".header-hamburger");

    /*
     * Accesibilidad:
     * mostramos directamente todos los elementos si el usuario
     * tiene activada la reducción de movimiento.
     */
    if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) {
      gsap.set([$header, $slider, $subtitle, $titleSpans, $heroLogo], {
        clearProps: "all"
      });

      return;
    }

    /*
     * Estados iniciales
     */
    gsap.set([$slider, $subtitle], {
      autoAlpha: 0,
      y: 12
    });

    gsap.set($titleSpans, {
      autoAlpha: 0,
      y: 14
    });

    gsap.set($header, {
      autoAlpha: 0,
      y: -80
    });

    gsap.set($heroLogo, {
      autoAlpha: 0,
      yPercent: 110
    });

    gsap.set($hamburger, {
      autoAlpha: 0
    });

    /*
     * Timeline de entrada
     */
    var introTimeline = gsap.timeline();

    introTimeline

      // Slider
      .to($slider, {
        autoAlpha: 1,
        y: 0,
        duration: 1.25,
        ease: "power3.out"
      })

      // H1
      .to(
        $titleSpans,
        {
          autoAlpha: 1,
          y: 0,
          duration: 1,
          stagger: 0.22,
          ease: "power3.out"
        },
        "-=0.4"
      )

      // Subtitle
      .to(
        $subtitle,
        {
          autoAlpha: 1,
          y: 0,
          duration: 1,
          ease: "power3.out"
        },
        "-=0.75"
      )

      // Header
      .fromTo(
        $header,
        {
          autoAlpha: 0,
          y: -80
        },
        {
          autoAlpha: 1,
          y: 0,
          duration: 2,
          ease: "expo.out"
        },
        "-=0.65"
      )

      // Logo
      .to(
        $heroLogo,
        {
          autoAlpha: 1,
          yPercent: 0,
          duration: 3,
          ease: "expo.out"
        },
        "<0.6 "
      )
      // Hamburger: solo fade in
      .to(
        $hamburger,
        {
          autoAlpha: 1,
          duration: 0.8,
          ease: "power2.out"
        },
        "-=1.85"
      );
  }

  function initHeaderLogoScroll() {
    ScrollTrigger.matchMedia({
      /*
       * Mobile:
       * no animamos ni scale ni padding del logo del header
       * ni del home hero logo.
       */
      "(max-width: 900px)": function() {
        var $menuLogo = $(".header-menu__item--logo");

        gsap.set($menuLogo, {
          clearProps: "transform,paddingTop"
        });

        var mobileLogoTimeline = gsap.timeline({
          scrollTrigger: {
            trigger: document.documentElement,
            start: "top top",
            end: "+=100",
            scrub: 0.7,
            invalidateOnRefresh: true
          }
        });

        mobileLogoTimeline.fromTo(
          $menuLogo,
          {
            x: 0,
            xPercent: -50,
            yPercent: 0,
            scale: 0.8,
            paddingTop: 83,
            transformOrigin: "50% 40%"
          },
          {
            x: 0,
            xPercent: -50,
            yPercent: -20,
            scale: 0.7,
            paddingTop: 25,
            transformOrigin: "50% 40%",
            ease: "none"
          }
        );

        gsap.set(".home-hero-logo", {
          clearProps: "paddingLeft,paddingRight,transform"
        });

        gsap.set(".home-hero-logo__heading", {
          clearProps: "transform"
        });

        return function() {
          mobileLogoTimeline.kill();

          gsap.set($menuLogo, {
            clearProps: "transform,paddingTop",
            x: 0,
            xPercent: -50,
            y: 0,
            yPercent: 0
          });
        };
      },

      /*
       * Desktop
       */
      "(min-width: 901px)": function() {
        var $menuLogo = $(".header-menu__item--logo");

        var $heroLogo = $(".home-hero-logo");
        var $heroIsa = $(".home-hero-logo__heading").first();
        var $heroRaw = $(".home-hero-logo__heading").last();

        var $footer = $(".footer");

        /*
         * Estado base.
         */
        gsap.set($heroLogo, {
          scale: 1,
          transformOrigin: "center bottom"
        });

        gsap.set($heroIsa, {
          transformOrigin: "left bottom"
        });

        gsap.set($heroRaw, {
          transformOrigin: "right bottom"
        });

        /*
         * Al salir del hero:
         * el logo del header se reduce
         * y el logo inferior se hace pequeño.
         */
        var tl = gsap.timeline({
          scrollTrigger: {
            trigger: document.documentElement,
            start: "top top",
            end: "+=120",
            scrub: 0.8,
            invalidateOnRefresh: true
          }
        });

        // Logo central del header
        tl.fromTo(
          $menuLogo,
          {
            xPercent: -50,
            yPercent: 0,
            scale: 1.1,
            transformOrigin: "50% -40%"
          },
          {
            xPercent: -50,
            yPercent: 0,
            scale: 0.75,
            transformOrigin: "50% -40%",
            ease: "none"
          },
          0
        );

        // Padding del home hero logo
        tl.fromTo(
          $heroLogo,
          {
            paddingLeft: 26,
            paddingRight: 36
          },
          {
            paddingLeft: 30,
            paddingRight: 30,
            ease: "none"
          },
          0
        );

        // ISA
        tl.fromTo(
          $heroIsa,
          {
            scale: 1,
            transformOrigin: "left bottom"
          },
          {
            scale: 0.5,
            transformOrigin: "left bottom",
            ease: "none"
          },
          0
        );

        // RAW
        tl.fromTo(
          $heroRaw,
          {
            scale: 1,
            transformOrigin: "right bottom"
          },
          {
            scale: 0.5,
            transformOrigin: "right bottom",
            ease: "none"
          },
          0
        );

        /*
         * Al llegar al footer:
         * ISA y RAW vuelven a hacerse grandes.
         */
        if ($footer.length) {
          var footerTimeline = gsap.timeline({
            scrollTrigger: {
              trigger: $footer[0],
              start: "top 90%",
              end: "top 55%",
              scrub: 0.8,
              invalidateOnRefresh: true,

              // markers: true
              // Se calcula después del pin de Services
              refreshPriority: -10
            }
          });

          // Recuperamos el padding inicial
          footerTimeline.fromTo(
            $heroLogo,
            {
              paddingLeft: 30,
              paddingRight: 30
            },
            {
              paddingLeft: 26,
              paddingRight: 36,
              ease: "none",
              immediateRender: false
            },
            0
          );

          // ISA vuelve a crecer
          footerTimeline.fromTo(
            $heroIsa,
            {
              scale: 0.5,
              transformOrigin: "left bottom"
            },
            {
              scale: 1,
              transformOrigin: "left bottom",
              ease: "none",
              immediateRender: false
            },
            0
          );

          // RAW vuelve a crecer
          footerTimeline.fromTo(
            $heroRaw,
            {
              scale: 0.5,
              transformOrigin: "right bottom"
            },
            {
              scale: 1,
              transformOrigin: "right bottom",
              ease: "none",
              immediateRender: false
            },
            0
          );
        }
      }
    });
  }

  function initServicesSlides() {
    var $services = $(".home-services");
    var $servicesContainer = $(".home-services-container");
    var $servicesWrapper = $(".home-services-wrapper");

    if (
      !$services.length ||
      !$servicesContainer.length ||
      !$servicesWrapper.length
    ) {
      return;
    }

    var mm = gsap.matchMedia();

    // Mobile: contenido en flujo natural, sin pin ni scrub.
    mm.add("(max-width: 900px)", function() {
      var allSlides = gsap.utils.toArray(
        ".home-services-wrapper .home-services-slide"
      );
      var introSlide = allSlides[0];
      var slides = allSlides.slice(1);
      var subtitles = gsap.utils.toArray(".home-services__subtitle");
      var $servicesSlider = $servicesWrapper.find(".home-services-slider");
      var $swiperWrapper = $servicesSlider.find(".swiper-wrapper");

      if ($servicesSlider[0] && $servicesSlider[0].swiper) {
        $servicesSlider[0].swiper.destroy(true, true);
      }

      // El primer bloque introductorio solo se muestra en desktop.
      if (introSlide) gsap.set(introSlide, { display: "none" });

      // El contenedor y los slides recuperan el flujo del documento.
      gsap.set([$servicesContainer[0], $servicesWrapper[0]], {
        height: "auto",
        minHeight: 0,
        overflow: "visible"
      });
      gsap.set([$servicesSlider[0], $swiperWrapper[0]].filter(Boolean), {
        height: "auto",
        overflow: "visible",
        transform: "none"
      });
      gsap.set($swiperWrapper, {
        display: "flex",
        flexDirection: "column",
        alignItems: "stretch"
      });
      gsap.set(slides, {
        display: "block",
        position: "relative",
        top: "auto",
        left: "auto",
        width: "100%",
        height: "auto",
        flexShrink: 0,
        opacity: 1,
        visibility: "visible",
        zIndex: "auto",
        transform: "none"
      });

      // Subtítulos: todos visibles, sin crossfades.
      // Su disposición final depende también del CSS de la sección.
      gsap.set(subtitles, {
        opacity: 1,
        visibility: "visible",
        y: 0
      });

      // Eliminar los estados iniciales ocultos del slider antiguo.
      gsap.set(
        $servicesWrapper.find(
          ".home-services-column--third, " +
            ".home-services-column__image--number, " +
            ".home-services-column__image, " +
            ".home-services-column__text, " +
            ".home-services-column-row"
        ),
        {
          clearProps: "opacity,visibility,transform"
        }
      );

      // IDs para navegación directa desde el menú mobile.
      slides.forEach(function(slide, i) {
        slide.id = "service-slide-" + i;
      });

      ScrollTrigger.refresh();

      // MOBILE: entrada suave de cada servicio al hacer scroll.

      // MOBILE: reveal suave sin parpadeos.
      var mobileReveals = [];

      // Preparamos las slides antes de crear las animaciones.
      gsap.set(slides, {
        autoAlpha: 0,
        y: 24
      });

      slides.forEach(function(slide) {
        var reveal = gsap.to(slide, {
          autoAlpha: 1,
          y: 0,
          duration: 0.85,
          ease: "power2.out",
          paused: true
        });

        var trigger = ScrollTrigger.create({
          trigger: slide,
          start: "top 88%",
          once: true,
          onEnter: function() {
            reveal.play();
          }
        });

        mobileReveals.push({
          reveal: reveal,
          trigger: trigger
        });
      });

      return function() {
        mobileReveals.forEach(function(reveal) {
          reveal.kill();
        });

        gsap.set(slides, {
          clearProps: "opacity,visibility,transform"
        });
        if (introSlide) gsap.set(introSlide, { clearProps: "display" });
        gsap.set([$servicesContainer[0], $servicesWrapper[0]], {
          clearProps: "height,minHeight,overflow"
        });
        gsap.set([$servicesSlider[0], $swiperWrapper[0]].filter(Boolean), {
          clearProps:
            "height,overflow,transform,display,flexDirection,alignItems"
        });
        gsap.set(slides, {
          clearProps:
            "display,position,top,left,width,height,flexShrink,opacity,visibility,zIndex,transform"
        });
        gsap.set(subtitles, { clearProps: "opacity,visibility,transform" });
        slides.forEach(function(slide, i) {
          if (slide.id === "service-slide-" + i) slide.removeAttribute("id");
        });
      };
    });

    // Desktop: mantenemos el timeline original sin cambios.
    mm.add("(min-width: 901px)", function() {
      var isMobile = false;

      var allSlides = gsap.utils.toArray(
        ".home-services-wrapper .home-services-slide"
      );

      var introSlide = allSlides[0];
      var slides = allSlides.slice();

      if (isMobile) {
        // Tablet + mobile: la introductoria desaparece completamente
        gsap.set(introSlide, {
          display: "none"
        });

        slides.shift();
      } else {
        gsap.set(introSlide, {
          clearProps: "display"
        });
      }

      var subtitles = gsap.utils.toArray(".home-services__subtitle");

      function getSubtitleBySlideIndex(index) {
        return subtitles.find(function(subtitle) {
          var subtitleIndex = Number($(subtitle).data("index"));

          if (isMobile) {
            subtitleIndex -= 1;
          }

          return subtitleIndex === index;
        });
      }

      if (!slides.length) {
        return;
      }

      var $servicesSlider = $servicesWrapper.find(".home-services-slider");

      var $swiperWrapper = $servicesSlider.find(".swiper-wrapper");

      /*
       * GSAP controla las slides.
       * Destruimos Swiper si ya está activo.
       */
      if ($servicesSlider[0] && $servicesSlider[0].swiper) {
        $servicesSlider[0].swiper.destroy(true, true);
      }

      /*
       * Eliminamos transforms de Swiper.
       */
      gsap.set($swiperWrapper, {
        clearProps: "transform"
      });

      gsap.set(slides, {
        clearProps: "transform"
      });

      /*
       * Altura del escenario.
       */
      gsap.set($servicesWrapper, {
        height: isMobile
          ? Math.max(window.innerHeight * 0.75, 600)
          : Math.max(window.innerHeight * 0.65, 620)
      });

      /*
       * Slides superpuestas.
       */
      gsap.set(slides, {
        position: "absolute",
        top: 0,
        left: 0,
        width: "100%",
        height: "100%",
        opacity: 0,
        visibility: "hidden",
        zIndex: 0
      });

      slides.forEach(function(slide, i) {
        gsap.set(slide, {
          zIndex: i + 1
        });
      });

      /*
       * Primera slide visible.
       */
      gsap.set(slides[0], {
        opacity: 1,
        visibility: "visible"
      });

      /*
       * Subtítulos.
       */
      gsap.set(subtitles, {
        autoAlpha: 0,
        y: 0
      });

      if (isMobile) {
        var firstMobileSubtitle = getSubtitleBySlideIndex(0);

        if (firstMobileSubtitle) {
          gsap.set(firstMobileSubtitle, {
            autoAlpha: 1,
            y: 0
          });
        }
      }

      /*
       * Primera slide introductoria.
       */
      var firstSlide = slides[0];

      var $introSlide = $(firstSlide);
      var $introColumns = $introSlide.find(".home-services-column--third");

      /*
       * Estado inicial de las tres columnas.
       */
      gsap.set($introColumns, {
        autoAlpha: 0,
        y: 45
      });

      $introColumns.each(function() {
        var $column = $(this);

        gsap.set($column.find(".home-services-column__image--number"), {
          autoAlpha: 0,
          y: 15
        });

        gsap.set($column.find(".home-services-column__image"), {
          autoAlpha: 0,
          y: 30,
          scale: 1.02,
          transformOrigin: "center bottom"
        });

        gsap.set($column.find(".home-services-column__text"), {
          autoAlpha: 0,
          y: 18
        });
      });

      /*
       * Entrada inicial de la primera slide.
       */
      var firstSlideTimeline = gsap.timeline({
        scrollTrigger: {
          trigger: $servicesContainer[0],
          start: "top 40%",
          once: true,
          invalidateOnRefresh: true
          // markers: true
        }
      });

      $services.data("servicesIntroTimeline", firstSlideTimeline);

      /*
       * Entrada stagger de las tres columnas.
       */
      firstSlideTimeline.to($introColumns, {
        autoAlpha: 1,
        y: 0,
        duration: 1.2,
        stagger: 0.18,
        ease: "power3.out"
      });

      /*
       * Animación interna de cada columna.
       */
      $introColumns.each(function(index) {
        var $column = $(this);

        /*
         * Cada columna empieza ligeramente después
         * de la anterior.
         */
        var position = 0.12 + index * 0.18;

        firstSlideTimeline.to(
          $column.find(".home-services-column__image--number"),
          {
            autoAlpha: 1,
            y: 0,
            duration: 0.5,
            ease: "power3.out"
          },
          position
        );

        firstSlideTimeline.to(
          $column.find(".home-services-column__image"),
          {
            autoAlpha: 1,
            y: 0,
            scale: 1,
            duration: 0.85,
            ease: "expo.out"
          },
          position + 0.08
        );

        firstSlideTimeline.to(
          $column.find(".home-services-column__text"),
          {
            autoAlpha: 1,
            y: 0,
            duration: 0.65,
            stagger: 0.08,
            ease: "power3.out"
          },
          position + 0.18
        );
      });

      /*
       * Preparamos las siguientes slides.
       */
      slides.forEach(function(slide, i) {
        if (i === 0) {
          return;
        }

        var image = slide.querySelector(".home-services-column__image");

        var leftTexts = slide.querySelectorAll(
          ".home-services-column--left .home-services-column__text"
        );

        var rows = slide.querySelectorAll(".home-services-column-row");

        if (image) {
          gsap.set(image, {
            opacity: 0,
            y: 20,
            scale: 1.02,
            transformOrigin: "center bottom"
          });
        }

        gsap.set(leftTexts, {
          opacity: 0,
          y: 15
        });

        gsap.set(rows, {
          opacity: 0,
          y: 16
        });
      });

      /*
       * Timeline principal.
       */
      var tl = gsap.timeline({
        scrollTrigger: {
          trigger: $servicesContainer[0],

          start: isMobile ? "top 20px" : "top 40px",

          /*
           * Recorrido mucho más corto.
           */
          end: function() {
            return "+=" + slides.length * window.innerHeight * 0.18;
          },

          pin: true,
          pinSpacing: true,

          /*
           * Responde antes al scroll.
           */
          scrub: 0.25,

          anticipatePin: 1,
          invalidateOnRefresh: true,
          // Se calcula antes que los triggers posteriores
          refreshPriority: 10

          // markers: true
        }
      });

      $services.data("servicesTimeline", tl);

      /*
       * Pausa inicial corta.
       */
      if (!isMobile) {
        tl.to(
          {},
          {
            duration: 0.2
          }
        );
      }

      /*
       * Cambios de slide.
       */
      slides.forEach(function(slide, i) {
        if (i === 0) {
          return;
        }

        var previousSlide = slides[i - 1];

        var image = slide.querySelector(".home-services-column__image");

        var leftTexts = slide.querySelectorAll(
          ".home-services-column--left .home-services-column__text"
        );

        var rows = slide.querySelectorAll(".home-services-column-row");

        var label = "services-slide-" + i;

        tl.add(label);

        /*
         * Nueva slide visible antes del fade.
         */
        tl.set(
          slide,
          {
            visibility: "visible"
          },
          label
        );

        /*
         * Crossfade corto.
         */
        tl.to(
          previousSlide,
          {
            opacity: 0,
            duration: 0.2,
            ease: "none"
          },
          label
        );

        tl.to(
          slide,
          {
            opacity: 1,
            duration: 0.2,
            ease: "none"
          },
          label
        );

        /*
         * Ocultamos la anterior al acabar el fade.
         */
        tl.set(
          previousSlide,
          {
            visibility: "hidden"
          },
          label + "+=0.2"
        );

        /*
         * Cambio de subtítulo.
         */
        var previousSubtitle = getSubtitleBySlideIndex(i - 1);
        var currentSubtitle = getSubtitleBySlideIndex(i);

        if (previousSubtitle) {
          tl.to(
            previousSubtitle,
            {
              autoAlpha: 0,
              y: -4,
              duration: 0.18,
              ease: "none"
            },
            label
          );
        }

        if (currentSubtitle) {
          tl.fromTo(
            currentSubtitle,
            {
              autoAlpha: 0,
              y: 6
            },
            {
              autoAlpha: 1,
              y: 0,
              duration: 0.3,
              ease: "power2.out"
            },
            label + "+=0.05"
          );
        }

        /*
         * Imagen.
         */
        if (image) {
          tl.to(
            image,
            {
              opacity: 1,
              y: 0,
              scale: 1,
              duration: 0.65,
              ease: "power3.out"
            },
            label + "+=0.03"
          );
        }

        /*
         * Textos izquierda.
         */
        if (leftTexts.length) {
          tl.to(
            leftTexts,
            {
              opacity: 1,
              y: 0,
              duration: 0.55,
              stagger: 0.08,
              ease: "power3.out"
            },
            label + "+=0.05"
          );
        }

        /*
         * Filas derecha.
         */
        if (rows.length) {
          tl.to(
            rows,
            {
              opacity: 1,
              y: 0,
              duration: 0.55,
              stagger: 0.09,
              ease: "power3.out"
            },
            label + "+=0.07"
          );
        }

        /*
         * Pausa corta antes de la siguiente.
         */
        tl.to(
          {},
          {
            duration: isMobile ? 0.05 : 0.3
          }
        );
      });

      ScrollTrigger.refresh();

      return function() {
        firstSlideTimeline.kill();
        tl.kill();
        $services.removeData("servicesTimeline");

        gsap.set($servicesWrapper, {
          clearProps: "height"
        });

        gsap.set($swiperWrapper, {
          clearProps: "transform"
        });

        gsap.set(slides, {
          clearProps:
            "position,top,left,width,height,opacity,visibility,zIndex,transform"
        });

        gsap.set(subtitles, {
          clearProps: "opacity,visibility,transform"
        });

        gsap.set(
          ".home-services-wrapper " +
            ".home-services-column__image, " +
            ".home-services-wrapper " +
            ".home-services-column__text, " +
            ".home-services-wrapper " +
            ".home-services-column-row",
          {
            clearProps: "opacity,visibility,transform"
          }
        );
        $services.removeData("servicesIntroTimeline");
      };
    });
  }

  function initManifestoImagesScroll() {
    var $manifesto = $(".home-manifesto");

    if (!$manifesto.length) {
      return;
    }

    var $imageWrapper = $manifesto.find(".home-manifesto__image-wrapper");

    var $firstImage = $manifesto.find(".home-manifesto__image--first");
    var $secondImage = $manifesto.find(".home-manifesto__image--second");
    var $thirdImage = $manifesto.find(".home-manifesto__image--third");

    // Estado inicial
    gsap.set($firstImage, {
      opacity: 1
    });

    gsap.set([$secondImage, $thirdImage], {
      opacity: 0
    });

    var tl = gsap.timeline({
      scrollTrigger: {
        trigger: $imageWrapper[0],
        start: "top 14%",
        end: "+=85",
        scrub: true,
        invalidateOnRefresh: true
        // markers: true
      }
    });

    // 1 → 2
    tl.to($firstImage, {
      opacity: 0,
      duration: 0.2,
      ease: "none"
    })
      .to(
        $secondImage,
        {
          opacity: 1,
          duration: 0.2,
          ease: "none"
        },
        "<"
      )

      // Pausa con la segunda imagen
      .to(
        {},
        {
          duration: 0.35
        }
      )

      // 2 → 3
      .to($secondImage, {
        opacity: 0,
        duration: 0.2,
        ease: "none"
      })
      .to(
        $thirdImage,
        {
          opacity: 1,
          duration: 0.2,
          ease: "none"
        },
        "<"
      );
  }

  function initMenuActiveStates() {
    var sections = [
      {
        trigger: ".home-services",
        menu: ".header-menu__item--services"
      },
      {
        trigger: ".home-manifesto",
        menu: ".header-menu__item--about"
      },
      {
        trigger: ".home-contact",
        menu: ".header-menu__item--contact"
      }
    ];

    sections.forEach(function(item) {
      ScrollTrigger.create({
        trigger: item.trigger,
        start: "top center",
        end: "bottom center",

        onEnter: function() {
          $(".header-menu__item").removeClass("active");
          $(item.menu).addClass("active");
        },

        onEnterBack: function() {
          $(".header-menu__item").removeClass("active");
          $(item.menu).addClass("active");
        },

        onLeave: function() {
          $(item.menu).removeClass("active");
        },

        onLeaveBack: function() {
          $(item.menu).removeClass("active");
        }
      });
    });
  }

  function initHomeServicesAnimations() {
    var $services = $(".home-services");

    if (!$services.length) {
      return;
    }

    ScrollTrigger.matchMedia({
      "(min-width: 901px)": function() {
        var $activeSlide = $services.find(
          ".home-services-slide.swiper-slide-active"
        );

        /*
         * Por si Swiper todavía no ha añadido swiper-slide-active.
         */
        if (!$activeSlide.length) {
          $activeSlide = $services.find(".home-services-slide").first();
        }

        var $leftTexts = $activeSlide.find(
          ".home-services-column--left .home-services-column__text"
        );

        var $rows = $activeSlide.find(".home-services-column-row");
        var $image = $activeSlide.find(".home-services-column__image");
        var $imageColumn = $activeSlide.find(".home-services-column--middle");

        /*
         * Estados iniciales
         */
        gsap.set($leftTexts, {
          autoAlpha: 0,
          y: 24
        });

        gsap.set($rows, {
          autoAlpha: 0,
          y: 30
        });

        gsap.set($image, {
          autoAlpha: 0,
          yPercent: 14,
          scale: 1.025,
          transformOrigin: "center bottom"
        });

        /*
         * Animación de entrada
         */
        var servicesTimeline = gsap.timeline({
          scrollTrigger: {
            trigger: $services[0],
            start: "center 70%",
            once: true
            // markers: true
          }
        });

        servicesTimeline

          /*
           * Textos de la izquierda
           */
          .to($leftTexts, {
            autoAlpha: 1,
            y: 0,
            duration: 1.15,
            stagger: 0.16,
            ease: "power3.out"
          })

          /*
           * Imagen desde abajo
           */
          .to(
            $image,
            {
              autoAlpha: 1,
              yPercent: 0,
              scale: 1,
              duration: 1.6,
              ease: "expo.out"
            },
            "-=0.75"
          )

          /*
           * Filas de servicios
           */
          .to(
            $rows,
            {
              autoAlpha: 1,
              y: 0,
              duration: 1.05,
              stagger: 0.18,
              ease: "power3.out"
            },
            "-=0.9"
          );

        /*
         * Parallax independiente.
         *
         * Animamos el contenedor de la imagen, no la propia imagen,
         * para que no interfiera con su animación de entrada.
         */
        gsap.fromTo(
          $imageColumn,
          {
            yPercent: -5
          },
          {
            yPercent: 7,
            ease: "none",
            scrollTrigger: {
              trigger: $services[0],
              start: "top bottom",
              end: "bottom top",
              scrub: 1.2,
              invalidateOnRefresh: true
            }
          }
        );
      }
    });
  }

  function initManifestoIntro() {
    var $manifesto = $(".home-manifesto-container");

    if (!$manifesto.length) {
      return;
    }

    gsap.set($manifesto, {
      autoAlpha: 0,
      y: 35
    });

    gsap.to($manifesto, {
      autoAlpha: 1,
      y: 0,
      duration: 1.2,
      ease: "power2.out",
      scrollTrigger: {
        trigger: $manifesto[0],
        start: "top 75%",
        once: true
        // markers: true
      }
    });
  }

  function initContactIntro() {
    var $contact = $(".home-contact-container");

    if (!$contact.length) {
      return;
    }

    gsap.set($contact, {
      autoAlpha: 0,
      y: 35
    });

    gsap.to($contact, {
      autoAlpha: 1,
      y: 0,
      duration: 1.6,
      ease: "power2.out",
      scrollTrigger: {
        trigger: $contact[0],
        start: "top 75%",
        once: true
        // markers: true
      }
    });
  }

  function updateMobileLogoFilter() {
    if ($(window).width() <= 900) {
      if ($(window).scrollTop() > 0) {
        $(".header-menu__item--logo").addClass("is-scrolled");
      } else {
        $(".header-menu__item--logo").removeClass("is-scrolled");
      }
    } else {
      $(".header-menu__item--logo").removeClass("is-scrolled");
    }
  }

  function initMobileHeaderScroll() {
    var $header = $(".header");
    var $logo = $(".header-menu__item--logo");
    var lastScroll = window.scrollY;
    var scrollUp = 0;
    var scrollDown = 0;

    $(window)
      .off("scroll.mobileHeader resize.mobileHeader")
      .on("scroll.mobileHeader", function() {
        if (window.innerWidth > 900) return;

        var currentScroll = Math.max(0, window.scrollY);
        var delta = currentScroll - lastScroll;

        if ($("body").hasClass("has-nav") || currentScroll < 100) {
          $logo.removeClass("is-hidden");
          scrollUp = 0;
          scrollDown = 0;
        } else if (delta > 0) {
          scrollDown += delta;
          scrollUp = 0;

          if (scrollDown > 10) {
            $logo.addClass("is-hidden");
          }
        } else if (delta < 0) {
          scrollUp += Math.abs(delta);
          scrollDown = 0;

          if (scrollUp > 5) {
            $logo.removeClass("is-hidden");
          }
        }

        lastScroll = currentScroll;
      })
      .on("resize.mobileHeader", function() {
        if (window.innerWidth > 900) {
          $logo.removeClass("is-hidden");
        }

        lastScroll = window.scrollY;
      });
  }

  function initServicesNavigation() {
    var serviceNames = ["brands", "experiences", "women"];

    // Localizamos la slide de cada servicio.

    function getServiceSlide(name) {
      var $services = $(".home-services");

      // Buscar directamente el elemento con el data-id.
      var $target = $services.find('[data-id="' + name + '"]').first();

      if (!$target.length) {
        console.warn("Servicio no encontrado:", name);
        return null;
      }

      // Si el data-id está dentro de una slide,
      // recuperamos la slide correspondiente.
      var $slide = $target.closest(".home-services-slide");

      // Si el data-id está en la propia slide.
      if (!$slide.length && $target.hasClass("home-services-slide")) {
        $slide = $target;
      }

      return $slide.length ? $slide[0] : $target[0];
    }

    function goToService(name) {
      var index = serviceNames.indexOf(name);

      if (index < 0) return false;

      // MOBILE: scroll natural.

      if (window.innerWidth <= 900) {
        var slide = getServiceSlide(name);

        if (!slide) return false;

        // Cerrar el menú.
        $("body").removeClass("has-nav");

        // Esperar a que el navegador actualice el layout.
        requestAnimationFrame(function() {
          requestAnimationFrame(function() {
            var target =
              slide.getBoundingClientRect().top + window.scrollY - 80;

            window.scrollTo({
              top: Math.max(0, target),
              behavior: "smooth"
            });
          });
        });

        return true;
      }

      // DESKTOP: salto directo al servicio.
      var tl = $(".home-services").data("servicesTimeline");

      if (!tl || !tl.scrollTrigger) return false;

      var label = "services-slide-" + (index + 1);
      var nextLabel = "services-slide-" + (index + 2);

      if (typeof tl.labels[label] === "undefined") {
        return false;
      }

      var startTime = tl.labels[label];

      var endTime =
        typeof tl.labels[nextLabel] !== "undefined"
          ? tl.labels[nextLabel]
          : tl.duration();

      var timelinePosition = startTime + (endTime - startTime) * 0.82;

      var progress = Math.max(0, Math.min(1, timelinePosition / tl.duration()));

      var st = tl.scrollTrigger;

      // Completar la animación introductoria antes de navegar.
      var introTl = $(".home-services").data("servicesIntroTimeline");

      if (introTl && introTl.isActive()) {
        introTl.progress(1);
      }

      // Saltar al servicio seleccionado.
      var target = st.start + (st.end - st.start) * progress;

      window.scrollTo(0, Math.round(target));
      ScrollTrigger.update();

      var introTl = $(".home-services").data("servicesIntroTimeline");

      if (introTl && introTl.isActive()) {
        introTl.progress(1);
      }

      // Recalculamos el destino tras la activación.
      requestAnimationFrame(function() {
        var updatedTarget = st.start + (st.end - st.start) * progress;

        // Solo corregimos si el pin ha desplazado el destino.
        if (Math.abs(window.scrollY - updatedTarget) > 2) {
          window.scrollTo(0, Math.round(updatedTarget));
        }

        ScrollTrigger.update();
        // Fade in del contenido después del salto.
        var stage = $(".home-services-wrapper")[0];

        gsap.fromTo(
          stage,
          { opacity: 0.35 },
          {
            opacity: 1,
            duration: 0.45,
            ease: "power2.out",
            overwrite: true,
            onComplete: function() {
              gsap.set(stage, { clearProps: "opacity" });
            }
          }
        );
      });

      return true;
    }

    // MENÚ MOBILE
    $(document)
      .off("click.servicesNavigation")
      .on(
        "click.servicesNavigation",
        'li[class*="js-service-slide-"] > a',
        function(e) {
          if (window.innerWidth > 900) return;

          var classes =
            $(this)
              .closest("li")
              .attr("class") || "";

          var match = classes.match(/\bjs-service-slide-(\d+)\b/);

          if (!match) return;

          var name = serviceNames[Number(match[1])];

          if (!name) return;

          e.preventDefault();

          goToService(name);
        }
      );

    // TRES COLUMNAS INTRODUCTORIAS DESKTOP
    var $introColumns = $(".home-services-wrapper .home-services-slide")
      .first()
      .find(".home-services-column--third");

    $introColumns.each(function(index) {
      if (index >= serviceNames.length) return;

      $(this).attr({
        role: "button",
        tabindex: "0",
        "aria-label": "Ver servicio " + serviceNames[index]
      });
    });

    $introColumns
      .off("click.servicesIntro keydown.servicesIntro")
      .on("click.servicesIntro", function(e) {
        if (window.innerWidth <= 900) return;

        if ($(e.target).closest("a, button").length) {
          return;
        }

        var index = $introColumns.index(this);

        if (index >= 0 && index < serviceNames.length) {
          goToService(serviceNames[index]);
        }
      })
      .on("keydown.servicesIntro", function(e) {
        if (window.innerWidth <= 900) return;

        if (e.key !== "Enter" && e.key !== " ") {
          return;
        }

        if ($(e.target).closest("a, button").length) {
          return;
        }

        e.preventDefault();

        var index = $introColumns.index(this);

        if (index >= 0 && index < serviceNames.length) {
          goToService(serviceNames[index]);
        }
      });
  }

  function init() {
    // Return early if no corresponding module is present
    if (!$(".home").length) {
      return;
    }

    /*
     * Esperamos a window.load para evitar que el slider aparezca
     * antes de que sus imágenes estén listas.
     */
    // $(window).on("load", function() {
    //   initHeaderLogoScroll();
    //   initGsap();
    //   initMenuActiveStates();
    //   initServicesSlides();
    //   //initHomeServicesAnimations();
    //   initManifestoImagesScroll();
    //   initManifestoIntro();
    //   initContactIntro();
    // });

    var hasStarted = false;

    function startAnimations() {
      if (hasStarted) {
        return;
      }

      hasStarted = true;

      updateMobileLogoFilter();
      initGsap();
      initHeaderLogoScroll();
      initMobileHeaderScroll();

      initMenuActiveStates();
      initServicesSlides();
      initServicesNavigation();

      initManifestoImagesScroll();
      initManifestoIntro();
      initContactIntro();

      ScrollTrigger.refresh();
    }

    if (document.readyState === "complete") {
      startAnimations();
    } else {
      $(window).one("load", startAnimations);
    }

    $(window).on("scroll resize", updateMobileLogoFilter);

    /*
     * Safari puede restaurar la página desde la bfcache.
     */
    $(window).on("pageshow", function(event) {
      if (event.originalEvent && event.originalEvent.persisted) {
        startAnimations();
        ScrollTrigger.refresh();
      }
    });
  }

  return {
    init: init
  };
})(jQuery);

jQuery(document).ready(Gsap.init);
